var map = {
	"./ICMAP-flag.png": "2061",
	"./ICMCapital-flag.png": "68e9",
	"./ICMEU-flag.png": "dbec",
	"./ICMMENA-flag.png": "c005",
	"./ICMMU-flag.png": "1fc1",
	"./ICMSC-flag.png": "e932",
	"./ICMVC-flag.png": "04d3",
	"./TradiNext-flag.png": "e2c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d53e";